import React, { useEffect, useState } from "react";
import ChatbotMessaging from "../userDashboard/Chatbot/messaging/chatMessaging";

const ChatbotUI = () => {
  const [messages, setMessages] = useState([]);
  const [inputMessage, setInputMessage] = useState("");
  const [showChat, setShowChat] = useState(false); // State to toggle chat visibility
  const [tempbBotId, setTempBotId] = useState("");

  const handleSendMessage = (e) => {
    e.preventDefault();
    if (!inputMessage.trim()) return;

    setMessages([...messages, { text: inputMessage, sender: "user" }]);
    setInputMessage("");

    // Placeholder for sending message to backend and receiving response
  };

  useEffect(() => {
    // Parse the bot ID from the URL when the component mounts
    const iframeId = "chatbase-toggle-button";
    const geturl = document.getElementById(iframeId);
    console.log(geturl, "ee");

    geturl && (geturl.style.display = "none");

    // dont know why this works but never ever touch it
    //   geturl.width = "450px";
    //   geturl.height = "100%";
    //   // geturl.style.pointerEvents = "none";
    //   const queryParams = new URLSearchParams(geturl.src);

    //   const id = queryParams.get("https://intelliver.app/iframe?botId"); // 'botId' is the name of the query parameter
    //   if (id) {
    //     //   console.log(id, "id");
    //     setTempBotId(id);
    //     // You can also directly fetch bot-specific data here or pass the botId to other components/functions
    //   } else {
    //   }
  }, []);

  //   useEffect;

  return (
    // <div className="">
    <ChatbotMessaging botId={tempbBotId} />
    /* <div
        <button
          onClick={() => setShowChat(!showChat)}
          className="text-white bg-blue-500 hover:bg-blue-600 focus:outline-none font-medium rounded-full text-sm p-2.5 text-center inline-flex items-center absolute bottom-2 right-2"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            className="w-6 h-6"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M15 12H9m12 0a9 9 0 11-18 0 9 9 0 0118 0z"
            />
          </svg>
        </button>
      </div> 
    </div> */
  );
};

export default ChatbotUI;
